/*
 * SuperNutriOmni — moeda automática por mercado
 * Brasil: BRL + bandeira do Brasil.
 * EUA: BRL -> USD + bandeira dos EUA.
 */
(function () {
  'use strict';

  var market = String(window.SN_MARKET_HANDLE || '').toLowerCase();
  var isUsa = market === 'usa';

  // Proteção para a futura ativação de USD nativo no mercado EUA.
  // Se a própria Shopify já entregar USD, não converta novamente.
  var shopifyCurrency = String(
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''
  ).toUpperCase();
  var usesNativeUsd = isUsa && shopifyCurrency === 'USD';

  if (usesNativeUsd) {
    document.documentElement.setAttribute('data-sn-display-currency', 'USD');
    document.documentElement.setAttribute('data-sn-native-usd', 'true');
    return;
  }

  var CACHE_KEY = 'sn_fx_brl_usd_v4';
  var CACHE_TTL = 6 * 60 * 60 * 1000;
  var FALLBACK_RATE = 0.19364;
  var RATE_ENDPOINT = 'https://open.er-api.com/v6/latest/BRL';

  // Preços oficiais USD do catálogo EUA.
  // Chave = preço-base Shopify em centavos de BRL; valor = preço oficial em centavos de USD.
  // Esses valores têm prioridade sobre a conversão cambial para que o preço exibido
  // corresponda exatamente ao preço oficial informado na descrição do produto.
  var OFFICIAL_USD_CENTS_BY_BRL_CENTS = {
    // SEYTÚ USA: cadastros oficiais em USD; produtos permanecem DRAFT.
    11754: 2276, // OML Plus Gel Premium
    22356: 4329, // SEYTÚ Leaf Body Butter (CBD) — sujeito a revisão legal
    885: 172,
    1230: 239,
    2084: 405,
    9998: 1943,
    12282: 2387,
    15709: 3053,
    16280: 3164,
    16563: 3219,
    16852: 3275,
    17135: 3330,
    17706: 3441,
    19136: 3719,
    20278: 3941,
    21133: 4107,
    21704: 4218,
    21992: 4274,
    22563: 4385,
    22846: 4440,
    23134: 4496,
    23705: 4607,
    24559: 4773,
    25702: 4995,
    26561: 5162,
    27132: 5273,
    27415: 5328,
    32556: 6327,
    33415: 6494,
    34545: 6549,
    34557: 6716,
    34840: 6605,
    38838: 7548,
    40269: 7826,
    58257: 11322
  };

  var currentRate = isUsa ? FALLBACK_RATE : 1;
  var observer = null;
  var scheduled = false;

  var FLAG_US =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 18">' +
      '<rect width="28" height="18" fill="#fff"/>' +
      '<g fill="#b22234">' +
      '<rect y="0" width="28" height="2"/><rect y="4" width="28" height="2"/>' +
      '<rect y="8" width="28" height="2"/><rect y="12" width="28" height="2"/>' +
      '<rect y="16" width="28" height="2"/>' +
      '</g>' +
      '<rect width="12" height="10" fill="#3c3b6e"/>' +
      '<g fill="#fff">' +
      '<circle cx="2" cy="2" r=".7"/><circle cx="5" cy="2" r=".7"/><circle cx="8" cy="2" r=".7"/><circle cx="11" cy="2" r=".7"/>' +
      '<circle cx="3.5" cy="4" r=".7"/><circle cx="6.5" cy="4" r=".7"/><circle cx="9.5" cy="4" r=".7"/>' +
      '<circle cx="2" cy="6" r=".7"/><circle cx="5" cy="6" r=".7"/><circle cx="8" cy="6" r=".7"/><circle cx="11" cy="6" r=".7"/>' +
      '<circle cx="3.5" cy="8" r=".7"/><circle cx="6.5" cy="8" r=".7"/><circle cx="9.5" cy="8" r=".7"/>' +
      '</g></svg>'
    );

  var FLAG_BR =
    'data:image/svg+xml;utf8,' +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 18">' +
      '<rect width="28" height="18" rx="1" fill="#009c3b"/>' +
      '<path d="M14 2.3 24 9 14 15.7 4 9Z" fill="#ffdf00"/>' +
      '<circle cx="14" cy="9" r="4.2" fill="#002776"/>' +
      '<path d="M10.6 8.2c2.5-.7 5.3-.5 7.4.6" fill="none" stroke="#fff" stroke-width=".7"/>' +
      '</svg>'
    );

  function readCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      var rate = Number(data && data.rate);
      var savedAt = Number(data && data.savedAt);
      if (!isFinite(rate) || rate <= 0) return null;
      return { rate: rate, savedAt: savedAt || 0 };
    } catch (e) {
      return null;
    }
  }

  function writeCache(rate) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        rate: rate,
        savedAt: Date.now()
      }));
    } catch (e) {}
  }

  function parseBRL(numberText) {
    var normalized = String(numberText || '')
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^0-9.-]/g, '');

    var value = Number(normalized);
    return isFinite(value) ? value : null;
  }

  function formatBRL(cents) {
    return 'R$ ' + (cents / 100).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function officialUsdCentsFromBrlCents(brlCents) {
    brlCents = Math.round(Number(brlCents));
    if (!isFinite(brlCents)) return null;

    if (Object.prototype.hasOwnProperty.call(
      OFFICIAL_USD_CENTS_BY_BRL_CENTS,
      brlCents
    )) {
      return Number(OFFICIAL_USD_CENTS_BY_BRL_CENTS[brlCents]);
    }

    return null;
  }

  // Preços oficiais SEYTÚ confirmados por produto, sem conflitos entre SKUs.
  // Atuam apenas no mercado EUA e somente quando o preço-base corresponde.
  var SN_SEYTU_OFFICIAL_BY_HANDLE = {
    'matte-liquid-lipstick': { brl: 12613, usd: 2442 },
    'pink-eyeshadow-palette': { brl: 20929, usd: 4052 },
    'brown-eyeshadow-palette': { brl: 20929, usd: 4052 },
    'oml-plus-gel-premium': { brl: 11754, usd: 2276 },
    'body-butter-seytu-leaf-cbd-isolate': { brl: 22356, usd: 4329 },
    'seytu-permanent-dye-ammonia-free-light-brown': { brl: 12038, usd: 2331 },
    'seytu-permanent-dye-ammonia-free-dark-brown': { brl: 12038, usd: 2331 },
    'seytu-permanent-dye-ammonia-free-red': { brl: 12038, usd: 2331 },
    'seytu-permanent-dye-ammonia-free-natural-black': { brl: 12038, usd: 2331 },
    'seytu-permanent-dye-ammonia-free-extra-light-blonde': { brl: 12038, usd: 2331 },
    'seytu-permanent-dye-ammonia-free-mocha': { brl: 12038, usd: 2331 },
    'seytu-permanent-dye-ammonia-free-light-blonde': { brl: 12038, usd: 2331 },
    'seytu-shampoo-color-protect': { brl: 12038, usd: 2331 },
    'hand-cream-vanilla-moisturizing-hand-care-seytu-usa': { brl: 2696, usd: 522 },
    'body-lotion-vanilla-coconut-lightweight-moisturizing-body-care-seytu-usa': { brl: 11466, usd: 2220 },
    'hand-cream-vanilla-coconut-fast-absorbing-moisturizing-hand-care-seytu-usa': { brl: 4127, usd: 799 },
    'body-wash-berries-gentle-moisturizing-body-cleanser-seytu-usa': { brl: 10320, usd: 1998 },
    'body-lotion-berries-nourishing-moisturizing-body-care-seytu-usa': { brl: 11466, usd: 2220 },
    'hand-cream-berries-fast-absorbing-nourishing-hand-care-seytu-usa': { brl: 4127, usd: 799 },
    'hand-cream-apple-pear-moisturizing-hand-care-seytu-usa': { brl: 2696, usd: 522 },
    'hand-cream-watermelon-melon-moisturizing-hand-care-seytu-usa': { brl: 2696, usd: 522 },
    'moisturizing-night-cream-overnight-hydration-renewal-care-seytu-usa': { brl: 18062, usd: 3497 },
    'moisturizing-day-cream-daily-hydration-environmental-protection-seytu-usa': { brl: 18062, usd: 3497 },
    'moisturizing-toner-refreshing-hydration-balance-care-seytu-usa': { brl: 20930, usd: 4052 },
    'facial-mask-deep-cleansing-skin-renewal-care-seytu-usa': { brl: 15198, usd: 2942 },
    'facial-cleansing-cream-gentle-makeup-removal-moisturizing-cleanse-seytu-usa': { brl: 12040, usd: 2331 },
    'ultrafine-facial-scrub-gentle-micro-exfoliation-radiance-care-seytu-usa': { brl: 11756, usd: 2276 },
    'eye-makeup-remover-gentle-waterproof-makeup-removal-seytu-usa': { brl: 10893, usd: 2109 },
    'aloe-vera-deep-moisturizing-eye-serum-hydration-fine-line-care-seytu-usa': { brl: 12329, usd: 2387 },
    'oml-lip-balm-nourishing-moisture-care-seytu-usa': { brl: 10320, usd: 1998 },
    'spot-perfecting-serum-sebum-control-matte-finish-care-seytu-usa': { brl: 12040, usd: 2331 },
    'spot-facial-dermo-cleanser-deep-pore-cleansing-sebum-care-seytu-usa': { brl: 11466, usd: 2220 },
    'spot-gel-localized-breakout-pore-care-seytu-usa': { brl: 9173, usd: 1776 },
    'facial-sunscreen-spf-50-dry-touch-daily-sun-protection-seytu-usa': { brl: 12329, usd: 2387 },
    'system-s-specialist-green-apple-probiotic-vitamin-supplement-seytu-usa': { brl: 25228, usd: 4884 },
    'make-up-bag-seytu-organized-cosmetic-carry-case-seytu-usa': { brl: 10608, usd: 2054 },
    'makeup-sponge-multifunctional-liquid-powder-applicator-seytu-usa': { brl: 5904, usd: 1143 },
    'face-brush-set-3-piece-soft-synthetic-brush-kit-seytu-usa': { brl: 17886, usd: 3463 },
    'eye-lip-brush-set-5-piece-precision-makeup-kit-seytu-usa': { brl: 17257, usd: 3341 },
    'moisturizing-lipstick-spf-15-10-shades-seytu-usa': { brl: 9746, usd: 1887 },
    'lip-gloss-7-shades-seytu-usa': { brl: 11756, usd: 2276 },
    'eyebrow-pencil': { brl: 6426, usd: 1243 },
    'eyeliner-pencil': { brl: 9173, usd: 1776 },
    'lip-liner-pencil': { brl: 6306, usd: 1221 },
    'eyelash-mascara': { brl: 10608, usd: 2054 },
    'eyebrow-liner-kit': { brl: 17489, usd: 3386 },
    'eyeliner-penliner': { brl: 8600, usd: 1665 },
    'liquid-eyeliner-black': { brl: 9173, usd: 1776 },
    'liquid-foundation-up-spf-15': { brl: 20223, usd: 3719 },
    'fortifying-shampoo': { brl: 17486, usd: 3386 },
    'h-specialist-supplement': { brl: 35830, usd: 6938 },
    'fortifying-hair-lotion': { brl: 24076, usd: 4662 },
    'special-care-shampoo-for-weak-hair': { brl: 11181, usd: 2165 },
    'multivitamin-hair-complex': { brl: 21783, usd: 4218 },
    'deep-repair-hair-mask': { brl: 11465, usd: 2220 },
    'natural-herbal-extracts-hair-conditioner': { brl: 8785, usd: 1701 },
    'natural-herbal-extracts-shampoo': { brl: 8785, usd: 1701 },
    'hair-gel': { brl: 6776, usd: 1312 },
    'stretch-mark-gel-cream-striover-centella-asiatica-body-care-seytu-usa': { brl: 17200, usd: 3330 },
    'toning-cream-body-care-for-skin-texture-softness-seytu-usa': { brl: 20639, usd: 3996 },
    'dark-spot-gel-targeted-tone-luminosity-care-seytu-usa': { brl: 20985, usd: 4063 },
    'neck-chest-hand-cream-dark-spot-moisture-care-seytu-usa': { brl: 19207, usd: 3719 },
    'facial-cleansing-foam-gentle-radiance-tone-care-seytu-usa': { brl: 16053, usd: 3108 },
    'facial-cleansing-foam-daily-deep-cleanse-refreshing-care-seytu-usa': { brl: 15770, usd: 3053 }
  };

  function seytuOfficialForElement(el, brlCents) {
    if (!isUsa || !el) return null;
    var handle = '';
    var card = el.closest && el.closest(
      '[data-product-handle], [data-product-url], .product-item, .product-card, .grid__item, .product'
    );
    if (card) {
      handle = String(card.getAttribute('data-product-handle') || '');
      if (!handle) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) {
          handle = (link.getAttribute('href') || '').split('/products/')[1] || '';
        }
      }
    }
    if (!handle && location.pathname.indexOf('/products/') >= 0) {
      handle = location.pathname.split('/products/')[1] || '';
    }
    handle = handle.split(/[?#/]/)[0].toLowerCase();
    var entry = SN_SEYTU_OFFICIAL_BY_HANDLE[handle];
    return entry && entry.brl === brlCents ? entry.usd : null;
  }

  function formatUsdForElement(brlAmount, el) {
    var cents = Math.round(Number(brlAmount) * 100);
    var official = seytuOfficialForElement(el, cents);
    return official === null ? formatUSDFromBRL(brlAmount) : formatUSDCents(official);
  }

  function formatUSDCents(usdCents) {
    return '$' + (Number(usdCents) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' USD';
  }

  function formatUSDFromBRL(brlAmount) {
    var brlCents = Math.round(Number(brlAmount) * 100);
    var officialUsdCents = officialUsdCentsFromBrlCents(brlCents);

    if (officialUsdCents !== null) {
      return formatUSDCents(officialUsdCents);
    }

    var usd = Number(brlAmount) * currentRate;
    return '$' + usd.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' USD';
  }

  function renderUsaCartTotals() {
    if (!isUsa || !document.querySelectorAll) return;

    var rows = document.querySelectorAll(
      'tr.line-item[data-sn-cart-unit-brl-cents]'
    );

    var sumUsdCents = 0;
    var allLinesExact = rows.length > 0;

    rows.forEach(function (row) {
      var unitBrlCents = Number(
        row.getAttribute('data-sn-cart-unit-brl-cents')
      );
      var lineBrlCents = Number(
        row.getAttribute('data-sn-cart-line-brl-cents')
      );
      var quantity = Number(row.getAttribute('data-sn-cart-qty')) || 1;

      var officialUnitUsdCents =
        officialUsdCentsFromBrlCents(unitBrlCents);

      var lineUsdCents;

      if (
        officialUnitUsdCents !== null &&
        lineBrlCents === unitBrlCents * quantity
      ) {
        lineUsdCents = officialUnitUsdCents * quantity;
      } else {
        allLinesExact = false;
        lineUsdCents = Math.round(
          (lineBrlCents / 100) * currentRate * 100
        );
      }

      sumUsdCents += lineUsdCents;

      var linePrice = row.querySelector(
        '.line-item__line-price > span:not(.sn-market-flag)'
      );

      if (linePrice) {
        var lineText = formatUSDCents(lineUsdCents);
        if (linePrice.textContent !== lineText) {
          linePrice.textContent = lineText;
        }
        ensureFlagForElement(linePrice, 'us');
      }
    });

    var cartTotal = document.querySelector(
      '[data-sn-cart-total-brl-cents]'
    );

    if (!cartTotal) return;

    var totalBrlCents = Number(
      cartTotal.getAttribute('data-sn-cart-total-brl-cents')
    );
    var discountBrlCents = Number(
      cartTotal.getAttribute('data-sn-cart-discount-brl-cents')
    ) || 0;

    var totalText;

    if (allLinesExact && discountBrlCents === 0) {
      totalText = formatUSDCents(sumUsdCents);
    } else {
      totalText = formatUSDFromBRL(totalBrlCents / 100);
    }

    if (cartTotal.textContent !== totalText) {
      cartTotal.textContent = totalText;
    }

    ensureFlagForElement(cartTotal, 'us');
  }

  function ensureFlagForElement(el, country) {
    if (!el || !el.parentNode) return;

    // Nunca trate a própria bandeira como elemento de preço.
    if (
      el.classList &&
      el.classList.contains('sn-market-flag')
    ) {
      return;
    }

    var prev = el.previousElementSibling;
    if (prev && prev.classList && prev.classList.contains('sn-market-flag')) {
      prev.style.backgroundImage =
        'url("' + (country === 'us' ? FLAG_US : FLAG_BR) + '")';
      return;
    }

    var flag = document.createElement('span');
    flag.className = 'sn-market-flag';
    flag.setAttribute('aria-hidden', 'true');
    flag.setAttribute('data-sn-no-currency-convert', '');
    flag.style.display = 'inline-block';
    flag.style.width = '22px';
    flag.style.height = '14px';
    flag.style.marginRight = '6px';
    flag.style.verticalAlign = '-2px';
    flag.style.borderRadius = '1px';
    flag.style.backgroundSize = 'cover';
    flag.style.backgroundPosition = 'center';
    flag.style.backgroundRepeat = 'no-repeat';
    flag.style.backgroundImage =
      'url("' + (country === 'us' ? FLAG_US : FLAG_BR) + '")';
    flag.style.boxShadow = '0 0 0 1px rgba(0,0,0,.10)';

    el.parentNode.insertBefore(flag, el);
  }

  function ensureFlagForTextNode(node, country) {
    if (!node || !node.parentElement) return;
    ensureFlagForElement(node.parentElement, country);
  }

  function isIgnored(node) {
    if (!node || !node.parentElement) return true;

    return !!node.parentElement.closest(
      'script, style, textarea, input, select, option, noscript, template, [data-sn-no-currency-convert]'
    );
  }

  function renderTaggedPrice(el) {
    if (!el || !el.getAttribute) return;

    var cents = Number(el.getAttribute('data-sn-brl-cents'));
    if (!isFinite(cents)) return;

    if (isUsa) {
      el.textContent = formatUsdForElement(cents / 100, el);
      ensureFlagForElement(el, 'us');
    } else {
      el.textContent = formatBRL(cents);
      ensureFlagForElement(el, 'br');
    }
  }

  function renderTaggedPrices(root) {
    root = root || document;

    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches('[data-sn-brl-cents]')
    ) {
      renderTaggedPrice(root);
    }

    if (!root.querySelectorAll) return;

    root.querySelectorAll('[data-sn-brl-cents]').forEach(function (el) {
      renderTaggedPrice(el);
    });
  }

  function processTextNode(node, force) {
    if (!node || node.nodeType !== 3 || isIgnored(node)) return;

    var liveText = node.nodeValue || '';

    if (!isUsa) {
      if (/R\$\s*[0-9]/.test(liveText)) {
        ensureFlagForTextNode(node, 'br');
      }
      return;
    }

    if (/\$\s*[0-9].*USD/.test(liveText)) {
      ensureFlagForTextNode(node, 'us');
      return;
    }

    var sourceText = liveText;

    if (/R\$\s*[0-9]/.test(liveText)) {
      node.__snOriginalBRL = liveText;
      node.__snLastRate = null;
      sourceText = liveText;
    } else if (force && node.__snOriginalBRL) {
      sourceText = node.__snOriginalBRL;
    } else {
      return;
    }

    if (!/R\$\s*[0-9]/.test(sourceText)) return;
    if (!force && node.__snLastRate === currentRate) return;

    var converted = sourceText.replace(
      /R\$\s*([0-9.]+(?:,[0-9]{1,2})?)(?:\s*BRL)?/g,
      function (full, amountText) {
        var brl = parseBRL(amountText);
        return brl === null ? full : formatUsdForElement(brl, node.parentElement);
      }
    );

    if (converted !== liveText) {
      node.nodeValue = converted;
    }

    node.__snLastRate = currentRate;
    ensureFlagForTextNode(node, 'us');
  }

  function walk(root, force) {
    root = root || document.body;
    if (!root) return;

    renderTaggedPrices(root);

    if (root.nodeType === 3) {
      processTextNode(root, force);
      return;
    }

    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) {
      return;
    }

    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      null
    );

    var node;
    while ((node = walker.nextNode())) {
      processTextNode(node, force);
    }

    renderUsaCartTotals();
  }

  function scheduleWalk(root) {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      walk(root || document.body, false);
    });
  }

  function startObserver() {
    if (observer || !document.body) return;

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          processTextNode(mutation.target, false);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 3) {
            processTextNode(node, false);
          } else if (node.nodeType === 1) {
            renderTaggedPrices(node);
            scheduleWalk(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function applyRate(rate, force) {
    rate = Number(rate);

    if (!isFinite(rate) || rate <= 0) {
      rate = FALLBACK_RATE;
    }

    currentRate = rate;
    walk(document.body, !!force);
    startObserver();

    document.documentElement.setAttribute(
      'data-sn-display-currency',
      isUsa ? 'USD' : 'BRL'
    );

    if (isUsa) {
      document.documentElement.setAttribute(
        'data-sn-fx-rate',
        String(currentRate)
      );
    }
  }

  async function fetchRate() {
    var response = await fetch(RATE_ENDPOINT, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) {
      throw new Error('FX request failed');
    }

    var data = await response.json();
    var rate = Number(data && data.rates && data.rates.USD);

    if (!isFinite(rate) || rate <= 0) {
      throw new Error('Invalid USD rate');
    }

    return rate;
  }

  async function refreshRate(cached) {
    try {
      var rate = await fetchRate();
      writeCache(rate);
      applyRate(rate, true);
    } catch (error) {
      var fallback = cached && cached.rate
        ? Number(cached.rate)
        : FALLBACK_RATE;

      applyRate(fallback, true);

      console.warn(
        '[SuperNutriOmni FX] Cotação externa indisponível; usando taxa de reserva.',
        error
      );
    }
  }

  function init() {
    if (!isUsa) {
      applyRate(1, true);
      return;
    }

    var cached = readCache();

    if (cached && cached.rate) {
      applyRate(cached.rate, true);
    } else {
      applyRate(FALLBACK_RATE, true);
    }

    var isFresh =
      cached &&
      cached.savedAt &&
      (Date.now() - cached.savedAt < CACHE_TTL);

    if (!isFresh) {
      refreshRate(cached);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();